/* eslint-env browser, jquery */
import alias from 'modules/landing-alias';
import classes from 'component-classes';
import query from 'component-query';
import page from 'modules/ab-page-js';
import bus from 'modules/npm-component/bus';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import domify from 'domify';
import container from 'modules/section-content';
import axios from 'axios';
import splash from './landing-page.pug';

export default function register() {
  alias.forEach(aname => {
    page(`/${aname}/:apptype/:idp`, getData, initial, render, loadScripts, initializePageSections);
  });
}

function getData(ctx, next) {
  return axios.get(`/api/auth-catalog${ctx.path}`).then(({ data }) => {
    ctx.data = Object.assign(
      {},
      {
        context: {
          origin: window.location.origin
        }
      },
      data
    );
    next();
  });
}

/**
 * Check for initial load and
 * stop or continue with middleware
 * load if not
 */

function initial(ctx, next) {
  const renderOptions = {
    metadata: ctx.data.metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash(ctx.data)) })
  };
  container.render(renderOptions);

  if (ctx.init) {
    return next();
  }
  return replace()(ctx, next);
}

/**
  * Page.js middleware for path
  * replacing
  *
  * @param {String} path
  * @return {Function} middleware
  * @api private
  */

function replace(path) {
  return function middleware(ctx, next) {
    const realPath = path || ctx.path;
    window.location.replace(realPath);
    next();
  };
}

function render(ctx, next) {
  // attachScrollTrackEvent();
  bus.once('page:change', () => {
    classes(query('html')).remove('basic-navs-mode');

    // $(window).off('scroll', onScroll);
    // detachScrollTrackEvent();
  });

  // toggle loading flag by removing html's class
  classes(query('html')).remove('auth0-website-loading');
  classes(query('html')).add('basic-navs-mode').add('header-dark');

  if (typeof window.prettyPrint === 'function') {
    query.all('pre').forEach(pre => {
      classes(pre).add('prettyprint');
    });
    window.prettyPrint();
  }
  $('pre').addClass('prettyprint-start');
  bus.emit('page:render');
  next();
}

// tabs

const $tabsLinks = $('.tabs__link');
const $tabs = $('.tabs__panel');
$tabsLinks.on('click', function(e) {
  e.preventDefault();
  $('.tabs__link.selected').removeClass('selected');
  $('.tabs__panel').removeClass('is-vis');
  $(this).addClass('selected');
  const $tabToShow = $(this).parent('li').index();
  $($tabs[$tabToShow]).addClass('is-vis');
});

/**
 * Script loader
 */

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/auth-catalog/vendor/highlight-fc8654573f.min.js', 'hljs', done);
  });

  batch.end(next);
}

/**
 * Script page
 */

function initializePageSections() {
  const positionSteps = $('.tutorial-steps').offset().top;
  const stepsHeight = $('.tutorial-steps').innerHeight();
  let tutorialButtonsHeight;

  hljs.configure({
    classPrefix: ''
  });

  const $itemPreCode = $('.item-content pre code');
  if ($itemPreCode.length > 0) {
    $itemPreCode.each(function(i, block) {
      const $snippet = $(this);

      if (!$snippet.hasClass('hljs')) {
        hljs.highlightBlock(block);
        $snippet.addClass('hljs');
      }

      if ($('.item-content pre code').length == $('.hljs').length) {
        $('.tutorial').addClass('tutorial-start');
      }
    });
  } else {
    $('.tutorial').addClass('tutorial-start');
  }

  // Tutorial section detect and add flag

  $(window).scroll(() => {
    if (
      $(window).scrollTop() > positionSteps + tutorialButtonsHeight &&
      $(window).scrollTop() < positionSteps + stepsHeight
    ) {
      if (!$('.tutorial-nav-steps').hasClass('opened')) {
        $('.tutorial-nav-steps').addClass('opened');
        $('.tutorial').addClass('opened');
      }

      for (let i = 0, steps = $('.tutorial-steps .item').length; i < steps; i += 1) {
        if (
          $(window).scrollTop() > $(`.item.step-${i}`).offset().top - tutorialButtonsHeight - 5 &&
          !$(`.buttons-steps-list li[${i}]`).hasClass('selected')
        ) {
          $('.buttons-steps-list li').removeClass('selected');
          $(`.buttons-steps-list li.btn-${i}`).addClass('selected');
        }
      }
    } else if ($('.tutorial-nav-steps').hasClass('opened')) {
      $('.tutorial-nav-steps').removeClass('opened');
      $('.tutorial').removeClass('opened');
    }
  });

  // Detect sections and add id

  $('.tutorial-steps .item').each(function(i) {
    $(this).addClass(`step-${i}`);
  });

  // Add Navbar buttons
  $('.tutorial-nav-steps').append(
    '<div class="container"><ul class="buttons-steps-list"></ul></div>'
  );

  for (let i = 0, steps = $('.tutorial-steps .item').length; i < steps; i += 1) {
    if (i === 0) {
      $('.buttons-steps-list').append(
        `<li class="selected">
          <div class="num">${i + 1}</div>
          <span>${$(`.item.step-${i} h3`).text()}</span>
        </li>`
      );
    } else {
      $('.buttons-steps-list').append(
        `<li>
          <div class="num">${i + 1}</div>
          <span>${$(`.item.step-${i} h3`).text()}</span>
        </li>`
      );
    }
    tutorialButtonsHeight = $('.tutorial-nav-steps').innerHeight();
  }

  // Detect btns and add functionality

  $('.buttons-steps-list li').each(function(i) {
    $(this).addClass(`btn-${i}`);
    $(`.btn-${i}`).click(() => {
      $('body, html').animate(
        {
          scrollTop: $(`.step-${i}`).offset().top - tutorialButtonsHeight
        },
        600
      );
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/auth-catalog/landing.js